import React from 'react';
import styles from './Shipturtle.module.css';
import TerminalBannerManager from '../components/TerminalBannerManager';

function Shipturtle() {
  return (
    <div className={styles.content}>
      <TerminalBannerManager />
    </div>
  );
}

export default Shipturtle;
